// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DownloadVariables_wrapper__orA57","dropdown":"DownloadVariables_dropdown__175IR"};